module.exports = __webpack_public_path__ + "static/media/jibing_geren_icon.089dc59f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jibing_geren_icon.png
// module id = 411
// module chunks = 0